// Единая точка конфигурации API.
// Все сервисы импортируют URL отсюда — не дублируют process.env напрямую.

export const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000'
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000/api'
